/** Resolve when an image URL has loaded, or immediately when url is absent. */
export function preloadImage(url: string | null | undefined): Promise<void> {
  if (!url) return Promise.resolve();
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => resolve();
    img.src = url;
  });
}
